import { render, staticRenderFns } from "./test.vue?vue&type=template&id=8e0fcdd0&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=8e0fcdd0&prod&lang=scss&scoped=true"
import style1 from "./test.vue?vue&type=style&index=1&id=8e0fcdd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0fcdd0",
  null
  
)

export default component.exports